import React from "react";
import { checkedImage, unCheckedImage } from "../../../assets/images";
type AppProps={
    isLeast:boolean;
    isUpperCase:boolean;
    isLowerCase:boolean;
    isSpecial:boolean;
    className:string;
  triangleClassName: string;
    isNumber:boolean
}
const PasswordValidationCard=({
    className,
    isLeast,
    isUpperCase,
    isLowerCase,
    isSpecial,
    triangleClassName,
    isNumber
    
}:AppProps)=>{
  return(
    <>
    <div className={className} style={{ display: "flex" }}>
      <div
        style={{
          marginLeft: "12%",
          display: "flex",
          flexDirection: "column",
          // gap: "20px",
        }}
        >
          <span> {isLeast ? (
          <img
            style={{ width: "15px", height: "15px" }}
            src={checkedImage}
            alt="checked"
          />
        ) : (
          <img
            style={{ width: "15px", height: "15px" }}
            src={unCheckedImage}
            alt="unchecked"
          />
        )}</span>
          <span>{isUpperCase ? (
          <img
            style={{ width: "15px", height: "15px" }}
            src={checkedImage}
            alt="checked"
          />
        ) : (
          <img
            style={{ width: "15px", height: "15px" }}
            src={unCheckedImage}
            alt="unchecked"
          />
          )}</span>
          <span>{isLowerCase ? (
          <img
            style={{ width: "15px", height: "15px" }}
            src={checkedImage}
            alt="checked"
          />
        ) : (
          <img
            style={{ width: "15px", height: "15px" }}
            src={unCheckedImage}
            alt="unchecked"
          />
        )}</span>
          <span>
        {isSpecial ? (
          <img
            style={{ width: "15px", height: "15px" }}
            src={checkedImage}
            alt="checked"
          />
        ) : (
          <img
            style={{ width: "15px", height: "15px" }}
            src={unCheckedImage}
            alt="unchecked"
          />
        )}</span>
          <span>
        {isNumber ? (
          <img
            style={{ width: "15px", height: "15px" }}
            src={checkedImage}
            alt="checked"
          />
        ) : (
          <img
            style={{ width: "15px", height: "15px" }}
            src={unCheckedImage}
            alt="unchecked"
          />
        )}</span>
       
        
      </div>
      <div
        style={{
          marginLeft: "4%",
          display: "flex",
          flexDirection: "column",
          textAlign: "start",
        }}
      >
        <span>At least 8 character long</span>
        <span>One uppercase character</span>
        <span>One lowercase character</span>
        <span>One special character</span>
        <span>One number</span>
      </div>

      
        </div>
        <div className={triangleClassName}></div>
      </>
  )
}
export default PasswordValidationCard